import { render, staticRenderFns } from "./InformasiLainnya.vue?vue&type=template&id=45c4c896&scoped=true&"
import script from "./InformasiLainnya.vue?vue&type=script&lang=js&"
export * from "./InformasiLainnya.vue?vue&type=script&lang=js&"
import style0 from "./InformasiLainnya.vue?vue&type=style&index=0&id=45c4c896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4c896",
  null
  
)

export default component.exports